import script from "./OverlayItem.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlayItem.vue?vue&type=script&setup=true&lang=js"

import "./OverlayItem.vue?vue&type=style&index=0&id=47e779fb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e779fb"]])

export default __exports__